/**
 * Paths of the customer-bank-statement-uploads JSON endpoints.
 *
 * Owning them here means they are greppable, they carry the canonical `/api` prefix in one place rather
 * than depending on which caller reconstructs the path, and they can be checked against the server: the
 * shared contracts declare the same paths, `bank-statement-uploads-urls.test.ts` asserts these match
 * them, and the Python tests prove each contract URL routes to the endpoint it names.
 */
const BASE = "/api/:customerSlug/customer-bank-statement-uploads";

/** Path templates. Resolve with `getBankStatementUploadsUrls` rather than substituting by hand. */
export const BANK_STATEMENT_UPLOADS_PATHS = {
  createUploadUrlPath: `${BASE}/create-upload-url`,
  confirmUploadPath: `${BASE}/confirm-upload`,
  deleteUploadPath: `${BASE}/delete-upload`,
  submitPath: `${BASE}/submit`,
} as const;

export type BankStatementUploadsPathName = keyof typeof BANK_STATEMENT_UPLOADS_PATHS;

export type BankStatementUploadsUrls = Record<BankStatementUploadsPathName, string>;

const resolve = (template: string, customerSlug: string): string =>
  template.replace(":customerSlug", encodeURIComponent(customerSlug));

/** Every customer-bank-statement-uploads endpoint URL for one customer. */
export const getBankStatementUploadsUrls = (customerSlug: string): BankStatementUploadsUrls =>
  Object.fromEntries(
    Object.entries(BANK_STATEMENT_UPLOADS_PATHS).map(([name, template]) => [name, resolve(template, customerSlug)])
  ) as BankStatementUploadsUrls;
